"use client";
import { filterProps } from "../../../../utils/filter-props/filter-props.mjs";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-style/resolve-vars/merge-vars.ts
function mergeVars(vars) {
	return vars.reduce((acc, current) => {
		if (current) Object.keys(current).forEach((key) => {
			acc[key] = {
				...acc[key],
				...filterProps(current[key])
			};
		});
		return acc;
	}, {});
}
//#endregion
export { mergeVars };

//# sourceMappingURL=merge-vars.mjs.map